import React, { useState } from "react";
import { colors } from "./constants";

export function TabBar({ tabs, tabLabels, activeTab, onSelect, onDeleteTab, deleteTitle }) {
  const [hoveredTab, setHoveredTab] = useState(null);

  return (
    <div
      style={{
        backgroundColor: colors.white,
        borderBottom: `1px solid ${colors.border}`,
        display: "flex",
        paddingLeft: "24px",
      }}
    >
      {tabs.map((tab) => (
        <div
          key={tab}
          onClick={() => onSelect(tab)}
          onMouseEnter={() => onDeleteTab && setHoveredTab(tab)}
          onMouseLeave={() => onDeleteTab && setHoveredTab(null)}
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: onDeleteTab ? "12px 28px 12px 20px" : "12px 20px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: activeTab === tab ? "600" : "400",
            color: activeTab === tab ? colors.activeBlue : "#666",
            borderBottom:
              activeTab === tab
                ? `3px solid ${colors.activeBlue}`
                : "3px solid transparent",
            transition: "all 0.2s",
          }}
        >
          {tabLabels[tab]}
          {onDeleteTab && hoveredTab === tab && (
            <button
              onClick={(e) => { e.stopPropagation(); onDeleteTab(tab); }}
              title={deleteTitle || "Remove"}
              style={{
                position: "absolute", top: "6px", right: "6px",
                background: "none", border: "none", cursor: "pointer",
                color: "#ccc", fontSize: "14px", padding: "0 2px", lineHeight: "1",
                display: "inline-flex", alignItems: "center",
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = colors.red}
              onMouseLeave={(e) => e.currentTarget.style.color = "#ccc"}>
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
